const removePhoneCountryPrefix = (phone, langCode) => {
  if (langCode === 'es') {
    if (phone.startsWith('+34')) {
      return phone.slice(3)  // '+34' son 3 caracteres
    }
    if (phone.startsWith('34')) {
      return phone.slice(2)  // '34' son 2 caracteres
    }
  } else if (langCode === 'fr') {
    if (phone.startsWith('+33')) {
      return phone.slice(3)  // '+33' son 3 caracteres
    }
    if (phone.startsWith('33')) {
      return phone.slice(2)  // '33' son 2 caracteres
    }
  }
  return phone
}
const phoneFormatAddSpaces = (phone) => {
    // añadimos un espacio cada 3 digitos empezando por el final
    if (!phone || typeof phone !== 'string') {
        return phone;
    }
    
    // Eliminamos espacios existentes
    const cleanPhone = phone.replace(/\s+/g, '');
    
    if (cleanPhone.length <= 3) {
        return cleanPhone;
    }
    
    // Calculamos cuántos caracteres sobran al dividir por 3
    const remainder = cleanPhone.length % 3;
    
    let result = '';
    let startIndex = 0;
    
    // Si hay resto, ajustamos el primer grupo para evitar dejar caracteres sueltos
    if (remainder === 1) {
        // Si sobra 1, el primer grupo tendrá 4 caracteres
        result = cleanPhone.slice(0, 4);
        startIndex = 4;
    } else if (remainder === 2) {
        // Si sobran 2, el primer grupo tendrá 2 caracteres para dejar el resto en grupos de 3  
        result = cleanPhone.slice(0, 2);
        startIndex = 2;
    } else {
        // Si no hay resto, el primer grupo tendrá 3 caracteres
        result = cleanPhone.slice(0, 3);
        startIndex = 3;
    }
    
    // Añadimos el resto en grupos de 3
    for (let i = startIndex; i < cleanPhone.length; i += 3) {
        result += ' ' + cleanPhone.slice(i, i + 3);
    }
    
    return result;
}

export const phoneFormat = (phone, langCode) => {
    const phoneWithoutCountryPrefix = removePhoneCountryPrefix(phone, langCode)
    const phoneWithSpaces = phoneFormatAddSpaces(phoneWithoutCountryPrefix)
    return phoneWithSpaces
}